//app.directive('ngRightClick', function ($parse) {
//    return function (scope, element, attrs) {
//        var fn = $parse(attrs.ngRightClick);
//        element.bind('contextmenu', function (event) {
//            scope.$apply(function () {
//                event.preventDefault();
//                fn(scope, { $event: event });
//            });
//        });
//    };
//});

'use strict';
ngRightClick.$inject = ['$parse'];

angular.module('schoolLinqApp').directive('ngRightClick', ngRightClick);

function ngRightClick($parse) {
	return function (scope, element, attrs) {
		var fn = $parse(attrs.ngRightClick);
		element.bind('contextmenu', function (event) {
			scope.$apply(function () {
				event.preventDefault();
				fn(scope, { $event: event });
			});
		});
	};
}
